import React from 'react';

import VerifyPhoneForm from '@components/forms/verifyPhone';

import useVerifyPhone from './hooks';

function VerifyPhone({
	isPostLogin,
	onSuccess,
	onDecline,
}: {
	isPostLogin?: boolean;
	onSuccess?: () => void;
	onDecline?: () => void;
}) {
	const { initialValues, onSubmit } = useVerifyPhone({ onSuccess });

	return (
		<VerifyPhoneForm
			initialValues={initialValues}
			isPostLogin={isPostLogin}
			onDecline={onDecline}
			onSubmit={onSubmit}
		/>
	);
}

export default VerifyPhone;
